<template>
  <div>
    <div>
      <div class="header_margin">      
      </div>    
    </div>
    <div align="center" justify="center">      
      <div class="text-center" id="blinking">
        <h2 id="typing-demo" class="white--text mt-8 mb-1  font-weight-light"></h2>
        <img                    
          src="../assets/logo_white.png"           
          width="300px"          
        />
      </div>      
      
    </div>
    
    <div>
      
      <div class="header_margin">
      </div>
      <div class="text-right" style="position: relative; width:100%; right:10px; color : #ffffffe0; font-size: 12px; font-weight: 300; ">The images used on this website were created using AI technology.</div>
    </div>    



    <div id="scoll_About" align="center" justify="center" >      
      <div class="mt-10">
        <div class="title_caption">ABOUT</div>
        <div class="title_header">M4 company</div>
        <div class="title_sub">Digital transformation of all indoor spaces with AI.</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/about.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            A company that generates<br>
            the most valueable, fastest and<br>
            most accurate<br> 
            indoor spatial information<br>
            with AI
          </div>
          <div class="content_caption text-left mt-4">
            M4 Company has core technologies such as AI-based 3D map generation solution, RTLS, and IoT, and is creating a beneficial, sustainable and valuable future for the company, customers, and everyone in the world with 
            <span @click="OpenImageNewWindow()" style="color:blue; cursor:pointer">Triple Win's</span>
            relationship orientation.
          </div>
        </div>
      </div>
      <!-- 반응형, 크기가 작을 때 -->
      <div class="ma-5 hidden-sm-and-up" style="">                            
        <img                              
          src="../assets/value_en.svg"           
          width="320px"/>                            
      </div>
      <!-- 반응형, 일반 화면 -->
      <div class="ma-5 hidden-xs-only" style="">                            
        <img                              
          src="../assets/value_en.svg"           
          width="400px"/>                            
      </div>
      
    </div>


    <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-10">
        <div class="title_caption">SOLUTION #1</div>
        <div class="title_header">OdyMAP</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/odymap_logo.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            3D indoor map generation tool/ viewer
          </div>
          <div class="content_caption text-left mt-4">
            OdyMAP provides a tool that allows anyone to quickly and easily generate 3D indoor maps using architectural CAD drawings in a web environment.
            By building indoor maps extensively, indoor map data can be provided to various industrial areas. In the future, we plan to create New Biz by issuing ownership rights to building owners and copyrights to map makers as NFTs and sharing part of the profits.
          </div>
          <div class="content_caption text-left mt-4">
            Demo viewer: <a href="https://ody.m-4.co.kr/#/MapView?BuildingId=1001&GroupId=1001" target="_blank">https://ody.m-4.co.kr/#/MapV...</a>
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                            
          <div class="image_title pa-3"><div>3D Map Tool</div></div>
          <img                              
            src="../assets/sol_01.jpg"           
            width="200px"/>                                    
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">3D Map Viewer</div>
          <img                              
            src="../assets/sol_02.jpg"           
            width="200px"/>                                    
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">Route Finder</div>
          <img                              
            src="../assets/sol_03.jpg"           
            width="200px"/>                                    
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">
            <div class="pt-3">IPS<p class="caption">(Indoor Positioning System)</p></div>
          </div>
          <img                              
            src="../assets/sol_04.jpg"           
            width="200px"/>                                    
        </div>        
      </div>
    </div>

    <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SOLUTION #2</div>
        <div class="title_header">M.RTLS</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img    
            class="img_outline"                          
            src="../assets/rtls.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            Real-time control system for security and safety management
          </div>
          <div class="content_caption text-left mt-4">
            We provide an access control system that manages only authorized personnel to access areas requiring security, safety management, and a real-time IoT sensor management system (gas, noise, vibration, weather, equipment, personnel, etc.) for safety management.
Based on 3D indoor map and indoor positioning technology, it provides real-time access management service (including emergency call function) and systematically manages stay time and access history by zone.
          </div>
          <div class="content_caption text-left mt-4">
            Demo site: <a href="https://rtls.m-4.co.kr/#/Login" target="_blank">https://rtls.m-4.co.kr</a><br>
            (ID: guest / PW: niceday777)
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                            
          <div class="image_title pa-3"><div>Real-time access control/emergency call</div></div>
          <div class="image_title" style="width: 300px; height: 200px; background-color: #ffffff;">
            <img                              
            src="../assets/sol_11.jpg"           
            width="300px"/>                                      
          </div>

          
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">IoT sensor management</div>
          <div class="image_title" style="width: 300px; height: 200px; background-color: #ffffff;">
            <img                              
            src="../assets/sol_12.jpg"           
            width="300px"/>                                      
          </div>
        </div>
        
      </div>
    </div>


    <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SOLUTION #3</div>
        <!-- 반응형, 크기가 작을 때 -->
        <div class="title_header2 hidden-sm-and-up" style="width:300;">M.blockchain</div>
        <!-- 반응형, 일반 화면 -->
        <div class="title_header hidden-xs-only" style="width:300;">M.blockchain</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" >                            
          <img 
            class="img_outline"
            src="../assets/blockchain.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            Blockchain mainnet base on DPOS 
          </div>
          <div class="content_caption text-left mt-4">
            It is a blockchain mainnet based on DPOS that implements 200 TPS and provides smart contracts.
            <img class="img"
            src="../assets/blockchain2.png"           
            width="300px"/>                                      
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                            
          <div class="image_title pa-3">Mainnet</div>
          <div class="image_title" style="height: 220px; background-color: #ffffff;">
            <img                              
            src="../assets/sol_31.jpg"           
            width="300px"/>                                      
          </div>
        </div>  
        <div class="ma-3">                            
          <div class="image_title pa-3">Trading Architecture</div>
          <div class="image_title" style="height: 220px; background-color: #ffffff;">
            <img                              
            src="../assets/mainnet2.png"           
            width="300px"/>                                      
          </div>
        </div>              
      </div>      
    </div>


    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #1</div>
        <div class="title_header">MIND</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/mind2.png"           
            width="220px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            108 bows counter
          </div>
          <div class="content_caption text-left mt-4">
            MIND is an app made by M4Company's mission to create a brighter, clearer, and more brilliant world.
            The MIND app provides a number counting function and meditation music that can help you during the exercise (108 bows). We also operate a bulletin board to share useful information to users.
          </div>
          <div class="mt-10">
            <h1 class="black--text">Get Mind</h1>          
            <div>MIND app provides count, music and timer that can help you with bowing, meditation<br>Play for free...</div>
            <div>
              <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=com.m4.mind" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>
              <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1584318132" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>         
            </div>
          </div>
        </div>
      </div>
    </div>


    
    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #2</div>
        <div class="title_header">M4Tarot</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/tarot.png"           
            width="220px"/>                            
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            Tarot cards based on AI technology
          </div>
          <div class="content_caption text-left mt-4">
            We use images generated based on AI technology and consult on selected tarot cards using LLM.<br>
            - Generated AI (image)<br>
            - Generate AI (LLM)<br>
            - Speak to Text (STT)<br>
            - Fine-tuning
          </div>
          <div class="mt-10">
            <h1 class="black--text">Get M4Tarot</h1>          
            <div>Enjoy tarot cards for free.</div>
            <div>
              <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=com.m4.app_tarot&pli=1" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>
              <!-- <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1584318132" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>          -->
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #3</div>
        <div class="title_header">EPITAPH</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <!-- 반응형, 크기가 작을 때 -->
        <div class="ma-3 hidden-sm-and-up" style="">                            
            <video controls width="300px" poster="../assets/EPITAPH_poster.png">
              <source src="../assets/EPITAPH.mp4" type="video/mp4">
            </video>
        </div>
        <!-- 반응형, 일반 화면 -->
        <div class="ma-3 hidden-xs-only" style="">                            
            <video controls width="560px" poster="../assets/EPITAPH_poster.png">
              <source src="../assets/EPITAPH.mp4" type="video/mp4">
            </video>
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            Digital memorial space<br>
            (AI technology-based)
          </div>
          <div class="content_caption text-left mt-4">
            We use AI technology to create a valuable and beautiful memorial space.<br>
            - AI deceased character creation<br>
            - Chat with AI characters (fine-tuning)<br>
            - Providing a digital memorial space to remember the deceased (photos, voices, episodes, etc.)<br>
            - Obituary notice
          </div>
          <div class="content_caption text-left mt-4">
            <a href="https://epitaph.m-4.co.kr" target="_blank">https://epitaph.m-4.co.kr</a>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #4</div>
        <div class="title_header">Ticchettio</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex;">
        <!-- 반응형, 크기가 작을 때 -->
        <div class="ma-3 mt-10 hidden-sm-and-up">                            
            <iframe width="300" height="166" src="https://www.youtube.com/embed/dnvBE-UyAxg?si=z93NQWVF-rJIiaB4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <!-- 반응형, 일반 화면 -->
        <div class="ma-3 mt-10 hidden-xs-only">                            
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dnvBE-UyAxg?si=z93NQWVF-rJIiaB4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            AI,Chat,Create image
          </div>
          <div class="content_caption text-left mt-4">
            Ticchettio is an AI-based service that creates new digital friends for users and provides personalized content.<br><br>
            - creates a unique character based on user input, which is designed to reflect user’s tastes, interests, and tendencies. Users can chat with characters they have created or with characters of interest that have already been created.<br>
            - the generated AI characters create their own short videos and blogs. Content and images are created using AI technology to match the character's characteristics.<br>
            - provides the ability to create and share images and personal blogs using AI. Users can enjoy the fun of communication by sharing the content they create with others.
          </div>
          <div class="mt-10">
            <div>
              <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=com.m4.app_Ticchettio" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>
              <!-- <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1584318132" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>          -->
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-5" id="scoll_History" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">HISTORY</div>
        <div class="title_header">M4 Company</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        

      <!-- 반응형, 크기가 작을 때 -->
      <div class="text-left hidden-sm-and-up" style="width:300px;">
        <v-timeline dense>
          <v-timeline-item color="blue">
            <div class="content_header" style="font-size: 40px;">2024</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>'Vector image generation method for creating indoor 3D drawings and method for creating indoor 3D drawings using the same' Patent registration (PN: 10-2732289)</div>            
          </v-timeline-item>                
          <v-timeline-item color="blue">
            <div class="content_header" style="font-size: 40px;">2023</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >08-Dec</v-chip>Ticchettio service launched</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >03-Dec</v-chip>Supply of Advanced disaster response integrated digital platform(portal)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>Epitaph service launched</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >30-Jun</v-chip>Supply of visit reservation system</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Mar</v-chip>Change of CEO (W.S.CHOI)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Feb</v-chip>Supply of emergency call system(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2">
            <div class="content_header" style="font-size: 40px;">2022</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >31-May</v-chip>Supply of process access control system(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Dec</v-chip>Capital increase (KRW 350 million)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >02-Jan</v-chip>Started developing OdyMAP2.0</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4">
            <div class="content_header" style="font-size: 40px;">2021</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>Relocated head office and changed company name to M4Company</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>MIND app development and service</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >14-Jun</v-chip>Established M4 (capital: KRW 100 million)</div>            
          </v-timeline-item>
        </v-timeline>
      </div>
      
      <!-- 반응형, 일반 화면 --> 
      <div class="text-left hidden-xs-only" style="width:1000px;">
        <v-timeline dense>
          <v-timeline-item color="blue">
            <div class="content_header" style="font-size: 40px;">2024</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>'Vector image generation method for creating indoor 3D drawings and method for creating indoor 3D drawings using the same' Patent registration (PN: 10-2732289)</div>            
          </v-timeline-item>            
          <v-timeline-item color="blue">
            <div class="content_header" style="font-size: 40px;">2023</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >08-Dec</v-chip>Ticchettio service launched</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >03-Dec</v-chip>Supply of Advanced disaster response integrated digital platform(portal)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>Epitaph service launched</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >30-Jun</v-chip>Supply of visit reservation system</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Mar</v-chip>Change of CEO (W.S.CHOI)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Feb</v-chip>Supply of emergency call system(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2">
            <div class="content_header" style="font-size: 40px;">2022</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >31-May</v-chip>Supply of process access control system(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Dec</v-chip>Capital increase (KRW 350 million)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >02-Jan</v-chip>Started developing OdyMAP2.0</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4">
            <div class="content_header" style="font-size: 40px;">2021</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>Relocated head office and changed company name to M4Company</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>MIND app development and service</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >14-Jun</v-chip>Established M4 (capital: KRW 100 million)</div>            
          </v-timeline-item>
        </v-timeline>
      </div>

    </div>


    <div class="mt-5" id="scoll_Contact" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">CONTACT</div>
        <div class="title_header">Contact M4 Company</div>
        
      </div>        
      <v-container fluid>
        <div
          class="flex"        
          flat        
          color="white"
        >
          <v-row
            class="ma-0"
            color="white"              
            align="center"              
            justify="center"                            
          >
            <div id="item-box3" class="ma-3 pa-3 black--text">        
              <div>M4 Company Co., Ltd.<br></div>
              <div>info@m-4.co.kr<br></div>
              <div>#624 Seongsu Academy Tower, 118 Seongsui-ro, Seongdong-gu, Seoul</div>                
              <div class="magnifyBorder ma-3 pa-6" onclick="location.href='tel:070-8844-0621'">                 
                <v-icon color="black darken-3" x-large>mdi-phone-in-talk</v-icon>
                <h2 class="mt-0 mb-n2">070-8844-0621</h2>
                <p class="mt-0 mb-0" style="font-size:12px; color:#888888">AM 10:00 ~ PM 04:30</p>
                <p class="mt-n3 mb-0" style="font-size:12px; color:#888888">fax : 02-6918-0946</p>
              </div>                              
            </div>
            <div id="item-box3"  class="ma-3 pa-3 black--text">
              <img                    
                
                src="../assets/m4map.png"           
                width="300px"          
                class="img_outline mt-3"
              />                    
            </div>                          
          </v-row>           
        </div>  
        </v-container>  
    </div>

    <v-dialog v-model="dialog2" max-width="400px">
      <div @click="close()">
        <v-card class="pa-3" align="center" justify="center" >
          <div class="title_sub">Triple Win</div>
          <div class="mb-3 title_sub">(Win Win Win)</div>
          <img                    
            src="../assets/tripe_win_en.svg"           
            width="300px"          
          />
          <div class="mt-3">I’m good, you’re good, and we all are good.</div>
        </v-card>
      </div>
    </v-dialog>


  </div>
</template>


<script>
import axios from "axios"

export default {
  metaInfo: {
    // title 입력하기
    title: '3D Indoor Map, RTLS, AI - M4company',
    // link tag 입력하기
    // link: [{rel: "canonical", href: 'www.site.com'}],
    // meta tag 입력하기
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { vmid: "description", name: "description", content: 'We provide a variety of services using AI and solutions such as RTLS and Iot based on incomparably easy and fast 3D indoor map generation technology.' }
      //vmid ↑ 메타 태그를 고유하게 만들어준다.
    ]
  },

  data: () => ({ 
    dialog : false,
    dialog2 : false,
    renderForce : false,
    version : "",    
    videoPath : null,    
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },

  },

  mounted () {                
    this.version = localStorage.getItem("Version");
    //console.log('current version :', this.version);  
    
    // 버전업이 되었으면 버전을 올리도록 처리  
    if (process.env.NODE_ENV === 'production') {  
      //console.log('version update check...');  
      //console.log(caches);  
      axios
        .get(`/version.json?timestamp=${new Date().getTime()}`)
        .then(res => {  
        //console.log('server version :', res.data.version);  
        if (res.data.version != this.version) {              
          if (this.version != "") {
            //this.deleteCash();                      
          } 
          localStorage.setItem("Version", res.data.version);                       
        }  
      });  
    }
  },
  methods: {
    OpenImageNewWindow(){
      this.dialog2 = true;
      // const imageUrl = "https://m-4.co.kr/img/tripe_win_en.svg"; // 여기에 이미지 URL을 입력하세요
      // const imageWidth = 850; // SVG 이미지의 너비
      // const imageHeight = 600; // SVG 이미지의 높이
      // window.open(imageUrl, '_blank', `width=${imageWidth},height=${imageHeight}`);
    },

    close(){
      this.dialog2 = false;
    },

  }
}
</script>

<style scoped>
.header_margin {    
  width:100%;
  height:100px;  
}
/* .header_text {    
  background: #000000;   
} */
.content_get {    
  z-index: 2;
  width:100%;
  float:top;
  background: #FFFFFF;   
}
.content_why {    
  width:100%;  
  background: #2A2A2A;   
}


#content_about {    
  width:80%;    
  line-height:200%;
}

#line-height {
  line-height:200%;
}

#item-box {
  width:300px;
  line-height:200%;
}

#item-box2 {
  width:200px;
  line-height:200%;
}
#item-box3 {
  width:400px;
  line-height:200%;
}



#blinking{
	-webkit-animation:blink 3s ease-in-out infinite alternate;
    -moz-animation:blink 3s ease-in-out infinite alternate;
    animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 


  .magnifyBorder {
    width:240px;
    line-height:200%;
    background: #FFFFFFAA;

    padding: 18px 36px;
    border-radius: 5px;
    box-shadow: inset 0 0 0 0.2px #222222;;
    transition: 300ms box-shadow cubic-bezier(0.4, 0, 0.6, 1), 300ms background-color cubic-bezier(0.4, 0, 0.6, 1), 300ms color cubic-bezier(0.4, 0, 0.6, 1);;
    color: #222222;
  }

  .magnifyBorder:hover {
      background: #FFFFFFE0;
      box-shadow: inset 0 0 0 4px #D6433B;
      color : #222222;
  }


  .class_play_btn{
    z-index: 200;
    position: relative;
    top : 70px;
    height : 0px;
  }

  .video_x_button{
    z-index: 100;
    position: absolute;    
    top : 0px;
    left : 0px;
    height: 25px;
    width : 100%;
    background: #00000000;   
  }

  .circle{
    border-radius: 50%;
    background: #00000010;   
    height : 200px;
    width : 200px;
    text-align: center;
    line-height: 200px;    
    font-size: 40px;
    
  }



#blinking1{
	-webkit-animation:blink 5s ease-in-out infinite alternate;
    -moz-animation:blink 5s ease-in-out infinite alternate;
    animation:blink 5s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 



#blinking2{
	-webkit-animation:blink 6s ease-in-out infinite alternate;
    -moz-animation:blink 6s ease-in-out infinite alternate;
    animation:blink 6s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 

  .title_caption {
    color:#00000030;
    font-weight: 400;
    font-size: 30px;
  }
  .title_header {
    color:#000000C0;
    font-weight: 700;
    font-size: 60px;
  }
  .title_header2 {
    color:#000000C0;
    font-weight: 700;
    font-size: 45px;
  }
  .title_sub {
    color:#000000C0;
    font-weight: 500;
    font-size: 25px;
  }
  .content_header {
    color:#000000C0;
    font-weight: 500;
    font-size: 23px;
  }
  .content_caption {
    color:#000000A0;
    font-weight: 300;
    font-size: 15px;
  }

  .image_title {    
    background: #00000010;
    height : 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    border-radius: 5px;  
  }

  .img_outline {
    border-radius: 10px; /* 모서리 둥글게 */
  }

  /* video[poster]{ 
    height:100%;
    width:100%;
    } */


</style>





<!--  -->